import { DeleteSite } from './DeleteSite';

export default DeleteSite;
